import { render, staticRenderFns } from "./GoodDamageTypesInput.vue?vue&type=template&id=28e5cdd4&scoped=true"
import script from "./GoodDamageTypesInput.vue?vue&type=script&lang=ts"
export * from "./GoodDamageTypesInput.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageTypesInput.vue?vue&type=style&index=0&id=28e5cdd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5cdd4",
  null
  
)

export default component.exports